<mat-dialog-content [@snFadeInDown]>
  <form class="dialog-form">
    <sn-brand-logo type="horizontal" class="brand-logo" size="md" [inverse]="true"> </sn-brand-logo>
    <main class="main-content">
      <h3 class="header">Connect to Evidence.com</h3>
      <div>
        <p>Your administrator requires you to link your Axon and Fusus accounts to proceed.</p>
      </div>
    </main>

    <mat-dialog-actions>
      <button mat-button color="success" (click)="connectToEcom()" [disabled]="isLoading">
        Sign in to Evidence.com
      </button>

      <button mat-button color="warn" (click)="logOut()">Close</button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>
